.page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    min-height: 100%;
    padding: 2rem 1.5rem;
    box-sizing: border-box;
    row-gap: 1rem;
    background: var(--background-color-beige, #faf8f4);
}

.fullPage {
    min-height: 100vh;
}

.image {
    width: min(70vw, 420px);
    height: auto;
}

.message {
    max-width: 480px;
}

.actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-top: 0.5rem;
}

.details {
    max-width: 100%;
    margin-top: 1rem;
    text-align: left;
}

.details pre {
    max-height: 40vh;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
}
